import LoginComponent from "../../components/LoginScreen/LoginComponent";

const LoginPage = () => {
    return (
        <div>
            <LoginComponent />
        </div>
    )
}
export default LoginPage;